import { useGlobal } from "../contexts/globalContext";
import { getMediaConstraints } from "../contexts/userMediaContext";

const useJanusVideoRoomActions = () => {
  const {
    JANUS_REF: {
      current: {
        plugin: { videoRoom },
      },
    },
  } = useGlobal();

  const videoRoomToggleAudio = (action) => {
    if (!videoRoom) {
      console.warn("useJanusVideoRoomActions: videoRoom is null");
      return;
    }

    action === "mute" ? videoRoom.muteAudio() : videoRoom.unmuteAudio();
  };

  const videoRoomToggleVideo = (action) => {
    if (!videoRoom) {
      console.warn("useJanusVideoRoomActions: videoRoom is null");
      return;
    }
    const media = action === "mute" ? { removeVideo: true } : getMediaConstraints();

    if (action === "mute") videoRoom.muteVideo();
    else videoRoom.unmuteVideo();

    videoRoom.createOffer({
      media,
      success: (jsep) => {
        console.log(`${action} VIDEO`);
        videoRoom.send({ message: { request: "configure" }, jsep });
      },
      error: (error) => {
        console.warn(`ERR: videoRoomToggleVideo: error while ${action.toUpperCase()}: `, error);
      },
    });
  };

  return {
    videoRoomToggleAudio,
    videoRoomToggleVideo,
  };
};

export default useJanusVideoRoomActions;
